<script>
import { mapState, mapActions } from 'vuex';
// import { setToken } from '@/scripts/axios';
// import { oauthGetToken, getProfile } from '@/scripts/api/account';
import { confirmConnectionCreation } from '@/scripts/api/connections';
import { goTo, errorCloseCallback, handleError } from '@/scripts/methods';
// import { clearAll } from '@/scripts/utils/store-dependent';

export default {
  name: 'ConnectPlatform',
  data() {
    return {};
  },
  components: {},
  computed: {
    ...mapState(['user']),
  },
  created() {
    this.fillDataFromUrl();
  },
  mounted() {},
  destroyed() {
    clearTimeout(this.redirectId);
  },
  methods: {
    ...mapActions({
      setUser: 'setUser',
      setError: 'setError',
      setErrorCloseCallback: 'setErrorCloseCallback',
    }),
    fillDataFromUrl() {
      // const { $route: route = null } = this;
      // const { platform } = route.params;

      /*  */
      const { href: redirectURL } = window.location;

      // if (!platform || !redirectURL) {
      //   console.warn(`platform = ${platform} | redirectURL = ${redirectURL}`);
      //   clearAll();

      //   this.setError('Parameters not provided');

      //   /* async */
      //   this.redirectId = setTimeout(() => {
      //     /* TODO: turn off in tests */
      //     this.setError(null);
      //     this.goTo('/login');
      //   }, 5000);

      //   return;
      // }

      this.register(redirectURL);
    },
    register(redirectURL = '') {
      return confirmConnectionCreation(redirectURL).then(id => {
        this.goTo({ path: '/settings', params: { newConnectionId: id } });
      });
      // .catch(this.handleError);
    },
    errorCloseCallback,
    handleError,
    goTo,
  },
};
</script>

<template>
  <div class="signup"></div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
</style>
